export enum eligibilityActionTypes {
	FETCH_FINGERPRINTS_LIST = 'FETCH_FINGERPRINTS_LIST',
	START_SET_BLOCK_LOADING = 'START_SET_BLOCK_LOADING',
	END_SET_BLOCK_LOADING = 'END_SET_BLOCK_LOADING',
	FAILED_LOADING = 'FAILED_LOADING',
	FETCH_BLOCK_LIST = 'FETCH_BLOCK_LIST',
	START_BLOCK_LIST_LOADING = 'START_BLOCK_LIST_LOADING',
	SET_BLOCK_LIST_TABLE_PAGINATION = 'SET_BLOCK_LIST_TABLE_PAGINATION'

}
